module.exports = __webpack_public_path__ + "static/media/13. Ritmos, Óleo en tela, 140 x 180 cm, 2020 copy.4c96c10a.png";